import React from 'react';
import { cn } from '../../utils/cn';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'secondaryAlt' | 'link';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  pill?: boolean;
  className?: string;
};

const VARIANTS = {
  primary: 'bg-teal-400 text-black border border-teal-400 hover:bg-white hover:text-teal-500 transition-colors',
  secondary: 'bg-transparent text-teal-500 border border-teal-500 hover:bg-teal-500 hover:text-white transition-colors',
  secondaryAlt: 'bg-transparent text-teal-400 border border-teal-400 hover:bg-teal-400 hover:text-black bg-transparent transition-colors',
  link: 'bg-transparent text-teal-500 border-0 shadow-none px-0 py-0 h-auto min-h-0 text-base font-medium hover:underline focus:underline',
};

const SIZES = {
  xs: 'px-2 py-1 text-xs',
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-6 py-3 text-base',
  lg: 'px-6 py-3 text-lg',
  xl: 'px-8 py-4 text-xl',
};

const baseStyles = 'inline-flex items-center justify-center rounded-lg font-semibold focus:outline-none focus:ring-2 focus:ring-teal-400 disabled:opacity-50 disabled:cursor-not-allowed';

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  pill = false,
  className = '',
  children,
  ...props
}) => {
  return (
    <button
      className={cn(
        baseStyles,
        VARIANTS[variant],
        SIZES[size],
        fullWidth && 'w-full',
        pill && 'rounded-full',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button; 